<template>
    <div class="pa-10" v-if="accessTokenLifetime && hasPermission('serversettings')">
        <div>
            <h2>Alkalmazásbeállítások</h2>
        </div>
        <strong>Fogyasztási határérték (fűtés):</strong> {{ heatingAcuLimit }}
        <v-text-field label="Fogyasztási határérték"
                      hide-details="auto"
                      type="number"
                      v-model.number="heatingAcuLimitNew"></v-text-field>
        <br>
        <strong>Fogyasztási határérték (melegvíz):</strong> {{ hotWaterAcuLimit }}
        <v-text-field label="Fogyasztási határérték"
                      hide-details="auto"
                      type="number"
                      v-model.number="hotWaterAcuLimitNew"></v-text-field>
        <br><br>
        <div>
            <h2>Rendszerbeállítások</h2>
        </div>
        <strong>Token élettartam (másodperc):</strong> {{ accessTokenLifetime }}
        <v-text-field label="Token élettartam (másodperc)"
                      hide-details="auto"
                      type="number"
                      v-model.number="accessTokenLifetimeNew"></v-text-field>
        <br>
        <v-btn depressed
               color="primary"
               @click="sendMessage">Adatok mentése</v-btn>
    </div>
</template>

<script>
import notify from "devextreme/ui/notify";
import axios from "axios";
import accountService from "@/services/account.service";

export default {
  data() {
    return {
        heatingAcuLimit: null,
        heatingAcuLimitNew: null,
        hotWaterAcuLimit: null,
        hotWaterAcuLimitNew: null,
        accessTokenLifetime: null,
        accessTokenLifetimeNew: null
    }
  },
  created() {
    if(this.hasPermission('serversettings')) {
        axios.get('api/ServerSettings').then(r => {
            this.heatingAcuLimit = r.data.heatingAcuLimit;
            this.heatingAcuLimitNew = r.data.heatingAcuLimit;
            this.hotWaterAcuLimit = r.data.hotWaterAcuLimit;
            this.hotWaterAcuLimitNew = r.data.hotWaterAcuLimit;
            this.accessTokenLifetime = r.data.accessTokenLifetime;
            this.accessTokenLifetimeNew = r.data.accessTokenLifetime;
      });
    }
  },
  methods: {
    hasPermission(permissionValue) {
      return accountService.userHasPermission(permissionValue);
    },
    sendMessage() {
      axios.post('api/ServerSettings', {
          heatingAcuLimit: this.heatingAcuLimitNew,
          hotWaterAcuLimit: this.hotWaterAcuLimitNew,
          accessTokenLifetime: this.accessTokenLifetimeNew
      }).then(r => {
          this.heatingAcuLimit = this.heatingAcuLimitNew;
          this.hotWaterAcuLimit = this.hotWaterAcuLimitNew;
          this.accessTokenLifetime = this.accessTokenLifetimeNew;

        notify({
          message: "Updated",
          position: {
            at: "top",
            offset: "0 40"
          }
        }, "success", 5000);
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>
